import React, { useMemo, useEffect } from 'react';
import get from 'lodash/get';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { useChartContext } from '../hooks';

import ChartHeader from './ChartHeader';
import ChartCanvas from './ChartCanvas';
import ChartLegend from './ChartLegend';

import styles from './styles.styl';
import ChartHeaderFixed from './ChartHeaderFixed';
import { PERIOD } from '../constants/period';

const ChartWrapper = ({
  footer,
  loading,
  setConfig,
  isModal,
  onLoad = noop,
  hasExternalHeader = false,
}) => {
  const { period, activeSource } = useChartContext();

  useEffect(() => {
    onLoad({ period });
  }, [period]);

  const config = useMemo(() => setConfig({ period }), [loading]);
  const nothing = isEmpty(get(config, 'data.datasets', [])) || loading;
  const isQuarterOrYear = [PERIOD.QUARTER, PERIOD.YEAR].includes(period);

  const props = {
    config,
    loading,
    nothing,
    activeSource,
    isQuarterOrYear,
  };

  return (
    <div className={styles.container}>
      {!hasExternalHeader && isModal && <ChartHeaderFixed {...props} />}
      <div className={styles.wrapper}>
        {!hasExternalHeader && !isModal && <ChartHeader {...props} />}
        <ChartCanvas {...props} />
        <ChartLegend {...props} />
      </div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
};

ChartWrapper.propTypes = {
  noTabs: PropTypes.bool,
  onLoad: PropTypes.func,
  footer: PropTypes.node,
  loading: PropTypes.bool,
  isModal: PropTypes.bool,
  setConfig: PropTypes.func,
  hasExternalHeader: PropTypes.bool,
};

export default ChartWrapper;



// WEBPACK FOOTER //
// ./src/components/common/Charts/ChartWrapper/index.jsx